import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import SEO from "./SEO";

export default function InsuranceInfo() {
  return (
    <div className="app">
      <SEO
        title="Osiguranje - TraveLina"
        description="Informacije o putnom osiguranju i osiguranju od otkaza putovanja."
        keywords="osiguranje putovanja, Grawe osiguranje, TraveLina"
      />
      <Navbar />
      <main>
        <section className="section" style={{ paddingTop: "6rem" }}>
          <div className="container">
            <article>
              <h1 style={{ marginBottom: "2rem", color: "#f97316", fontSize: "2rem" }}>
                Osiguranje
              </h1>
              <div
                style={{
                  padding: "2rem",
                  background: "#fafafa",
                  borderRadius: "0.75rem",
                  border: "1px solid rgba(0, 0, 0, 0.08)",
                  fontSize: "0.95rem",
                  lineHeight: "1.8",
                  color: "#111827",
                  whiteSpace: "pre-wrap",
                }}
              >
                {`Za putnike TraveLina putovanja preporučujemo ugovaranje putnog osiguranja i osiguranja od otkaza putovanja.

Partner za osiguranje je GRAWE Hrvatska d.d.
Ulica grada Vukovara 5, Zagreb
Djelatnost: 65120 – Ostalo osiguranje, osim životnog
OIB: 28406115764
MBS: 00409880

Što možete ugovoriti:
- Putno zdravstveno osiguranje
- Osiguranje od nezgode
- Osiguranje prtljage
- Osiguranje od otkaza putovanja

Važne napomene:
- Osiguranje nije automatski uključeno u cijenu aranžmana, osim ako to nije posebno navedeno u programu.
- Putnik samostalno odlučuje o ugovaranju osiguranja, a TraveLina može pomoći oko informacija i procesa.
- Preporučujemo ugovaranje police odmah nakon potvrde rezervacije.

Za ponudu i aktivaciju police kontaktirajte:
Email: info@linatravelina.eu
Telefon: +385 91 214 4477`}
              </div>
            </article>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
